module.exports = __webpack_public_path__ + "img/29.4041daa8.jpg";